export const isDevEnvironment = () => {
  const sfEnv = process.env.REACT_APP_SF_ENV;
  return sfEnv === 'develop';
};

export const isProdEnvironment = () => {
  const sfEnv = process.env.REACT_APP_SF_ENV;
  return sfEnv === 'prod';
};
